// @flow

import styled from 'styled-components';

import type { Theme } from '../../../../../../types';

export const Star = styled<any, Theme>('i')`
  border-right: .3em solid transparent;
  border-bottom: .7em  solid ${props => props.theme.ribbon.color};
  border-left: 0.3em solid transparent;
  position: relative;
  display: inline-block;
  font-size: 0.2em;
  height: 0;
  margin-bottom: 1.2em;
  margin-left: .9em;
  margin-right: .9em;
  width: 0;
  z-index: 2;

  &:before, &:after {
    border-bottom: .7em  solid ${props => props.theme.ribbon.color};
    border-left: 1em solid transparent;
    border-right: 1em solid transparent;
    content: '';
    display: block;
    height: 0;
    position: absolute;
    transform: rotate(-35deg);
    left: -1em;
    top: .6em;
    width: 0;
  }

  &:after {
    transform: rotate(35deg);
  }
`;

export default null;
